import styled, { css } from 'styled-components';

import {
  getThemeColor,
  getThemeTransition,
  getTypographyStyle,
  media,
} from '@utils/styled';

import Typography from '@common/components/Typography';

export const CardStyles = css`
  position: relative;
  display: flex;
  ${({ theme }) => theme.getFluidSpacing('padding', 'widthBased', 2)};
  justify-content: center;
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadows[0]};
  border-radius: ${({ theme }) => theme.borderRadiuses['normal.1']}rem;
  background-color: ${getThemeColor('grey.100')};
  color: inherit;
  text-decoration: none;

  ${
    /* sc-block */ ({ href }) =>
      href &&
      css`
        transition: ${getThemeTransition('box-shadow', 'fast')};

        &:hover,
        &:focus {
          box-shadow: ${({ theme }) => theme.shadows[1]};
        }
      `
  }
`;

export const StyledCard = styled.div`
  ${CardStyles};

  ${({ isButton }) =>
    isButton &&
    css`
      cursor: pointer;
      background-color: ${getThemeColor('grey.100')};
      border: none;
    `};
`;

export const StyledCardLink = styled.a`
  ${CardStyles};
`;

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-items: center;

  > :last-child {
    ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 6)};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    height: auto;
  }
`;

export const CardText = styled(Typography).attrs({ variant: 'body3' })`
  margin: 0;
  font-weight: 500;
  text-align: center;

  ${media.from480up`
    ${getTypographyStyle('h5')};
  `}
`;

export const PillWrapper = styled.div`
  position: absolute;
  top: -0.8rem;
  right: -1rem;
`;
